<template>
  <div class="box-detail">
    <div class="box-left" :style="setLeftStyle()">
      <div class="box-left-header">
        <div>
          <span class="c-p-10 c-font-bold">调度中心</span>
        </div>
      </div>
      <div class="filter">
        <div
          v-if="tenantId != '2530349872480957853' && options.filters && options.filters.length > 0"
        >
          <el-select
            v-model="searchFilter"
            placeholder="筛选条件"
            clearable
            class="w-1"
            @change="this.getServiceAppointments"
          >
            <el-option
              v-for="item in options.filters"
              :key="item._id"
              :label="item.name"
              :value="item.plans"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-date-picker
            clearable
            v-model="searchTime"
            type="datetimerange"
            :picker-options="date.pickerOptions"
            range-separator="至"
            start-placeholder="预约时间"
            end-placeholder="预约时间"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="
              getServiceAppointments();
              $forceUpdate();
            "
          ></el-date-picker>
        </div>
        <div>
          <el-input
            placeholder="请输入工单标题/编号/姓名/手机"
            prefix-icon="el-icon-search"
            v-model="searchValue"
            clearable
            @input="getServiceAppointments"
            @keyup.enter="getServiceAppointments"
            @clear="getServiceAppointments"
          ></el-input>
        </div>
      </div>
      <div class="box-left-content">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__header el-table">
          <thead>
            <tr>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_1 is-leaf el-table__cell"
                style="width:50px;"
              >
                <div class="cell">编号</div>
              </th>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_2 is-leaf el-table__cell"
                style="width:80px;"
              >
                <div class="cell">工单</div>
              </th>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_5 is-leaf el-table__cell"
                style="width:270px;"
              >
                <div class="cell">客户地址</div>
              </th>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_6 is-leaf el-table__cell"
                style="width:300px;"
              >
                <div class="cell c-center" style="text-align: left !important;">使用产品</div>
              </th>

              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_3 is-leaf el-table__cell"
                style="width:100px;"
              >
                <div class="cell c-center" style="text-align: left !important;">预约时间段</div>
              </th>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_4 is-leaf el-table__cell"
                style="width:70px;"
              >
                <div class="cell" style="width:80px;">客户姓名</div>
              </th>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_3 is-leaf el-table__cell"
                style="width:90px;"
              >
                <div class="cell c-center">预约日期</div>
              </th>
              <th
                colspan="1"
                rowspan="1"
                class="el-table_5_column_6 is-leaf el-table__cell"
                style="width:300px;"
              >
                <div class="cell c-center" style="text-align: left !important;">指定工人备注</div>
              </th>
            </tr>
          </thead>
          <draggable v-model="fpi.data" element="tbody" group="dispatch" ghostClass="sa-ghost">
            <transition-group id="sas" style="min-height: 100px; display: block; width:1300px">
              <tr class="el-table__row hover-row" v-for="(item, i) in fpi.data" :key="i">
                <td rowspan="1" colspan="1" class="el-table_5_column_1 el-table__cell">
                  <div class="cell el-tooltip" style="width: 50px;">
                    <el-tooltip effect="light" :content="item.title" placement="top">
                      <el-button
                        type="text"
                        @click="
                          osg.open(null, null, '_blank', '/Flow/serviceAppointment/' + item._id)
                        "
                      >
                        {{ item.orderNum }}
                      </el-button>
                    </el-tooltip>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_5_column_2 el-table__cell">
                  <div class="cell el-tooltip" style="width: 80px;">
                    <span v-if="item.exts.again">{{ format('again', item.exts.again) }}</span>
                    <span>{{ format('workflowDefId', item.exts.workflowDefId) }}</span>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_5_column_4 el-table__cell">
                  <div class="cell el-tooltip" style="width: 270px;">
                    <el-tooltip
                      effect="light"
                      :content="item.exts.newAddress || item.address || ''"
                      placement="top"
                    >
                      <el-button type="text" style="color:#606266;">
                        {{ item.exts.newAddress || item.address || '' }}
                      </el-button>
                    </el-tooltip>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_5_column_4 el-table__cell">
                  <div class="cell el-tooltip" style="width: 300px;">
                    <el-tooltip
                      effect="light"
                      :content="formatProduct(item.exts.request)"
                      placement="top"
                    >
                      <el-button type="text" style="color:#606266;">
                        {{ formatProduct(item.exts.request) }}
                      </el-button>
                    </el-tooltip>
                  </div>
                </td>

                <td rowspan="1" colspan="1" class="el-table_5_column_5 el-table__cell">
                  <div class="cell el-tooltip" style="width: 100px;">
                    <el-tooltip
                      effect="light"
                      :content="
                        item.applyTime ||
                          (item.exts.visitDate
                            ? item.exts.visitTime && item.exts.visitTime.length > 0
                              ? formatArray('visitTime', item.exts.visitTime)
                              : ''
                            : '')
                      "
                      placement="top"
                    >
                      <el-button type="text" style="color:#606266;">
                        {{
                          item.applyTime ||
                            (item.exts.visitDate
                              ? item.exts.visitTime && item.exts.visitTime.length > 0
                                ? formatArray('visitTime', item.exts.visitTime)
                                : ''
                              : '')
                        }}
                      </el-button>
                    </el-tooltip>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_5_column_3 el-table__cell">
                  <div class="cell el-tooltip" style="width: 70px;">{{ item.name }}</div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_5_column_5 el-table__cell">
                  <div class="cell el-tooltip" style="width: 90px;">
                    <el-tooltip
                      effect="light"
                      :content="item.applyTime || (item.exts.visitDate ? item.exts.visitDate : '')"
                      placement="top"
                    >
                      <el-button type="text" style="color:#606266;">
                        {{ item.applyTime || (item.exts.visitDate ? item.exts.visitDate : '') }}
                      </el-button>
                    </el-tooltip>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_5_column_1 el-table__cell">
                  <div class="cell el-tooltip" style="width: 300px;">
                    {{ item.exts.confirmWorker }}
                  </div>
                </td>
              </tr>
            </transition-group>
          </draggable>
        </table>
      </div>
      <div class="box-left-footer c-p-0">
        <el-pagination
          v-if="tenantId == '2530349872480957853'"
          class="pagination c-center"
          :current-page="fpi.page"
          layout="total"
          :total="fpi.total"
        >
          <span style="min-width: 10px;text-align: center;">{{ fpi.page }}</span>
        </el-pagination>
        <el-pagination
          v-else
          class="pagination c-center"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-size="fpi.rows"
          :page-sizes="[20, 100, 500, 1000]"
          layout="total,prev,slot,next,sizes"
          :total="fpi.total"
        >
          <span style="min-width: 10px;text-align: center;">{{ fpi.page }}</span>
        </el-pagination>
      </div>
    </div>
    <div class="line" id="line" style="width:15px"><span>|||</span></div>
    <div class="box-center" :style="setRightStyle()">
      <el-tabs v-model="activeTab" class="c-flex c-flex-col c-h-1">
        <el-tab-pane label="派工" name="dispatch">
          <div class="c-flex c-flex-between c-flex-item">
            <span class="c_gray_drak">
              1.您可以将左侧工单拖拽到右侧服务资源后，进行排班。2.排班后点击「批量派单」按钮完成批量派单。
            </span>
            <el-button @click="dispatch" type="warning" size="medium">批量派单</el-button>
          </div>
          <div class="c-flex-1" style="overflow-y:auto">
            <div v-for="(item, i) in serviceResources" :key="i" class="sr-card">
              <el-card shadow="never" class="card-sr">
                <div class="w-1 c_flex c_flex_around c-flex-item">
                  <span>{{ item.name }}</span>
                  <span class="f-s-12" :class="item.workType == '-1' ? 'c_red' : ''">
                    {{ format('workState', item.workType) }}
                  </span>
                </div>
                <div v-if="item.exts.phone">{{ item.exts.phone }}</div>
                <div v-if="item.exts.plateNumber">{{ item.exts.plateNumber }}</div>
              </el-card>
              <draggable
                v-model="item.exts.serviceAppointments"
                ghostClass="sr-ghost"
                group="dispatch"
                handle=".mover"
                class="card-sas"
                @add="dragEnd"
              >
                <transition-group :id="i">
                  <el-card
                    v-for="(item, j) in item.exts.serviceAppointments"
                    :key="j"
                    :class="item.exts.dispatched != '1' ? 'mover' : ''"
                    id="j"
                  >
                    <div class="w-1 c-flex c-flex-between">
                      <span>编号：{{ item.orderNum }}</span>
                      <span>
                        <span v-if="item.exts.again">{{ format('again', item.exts.again) }}</span>
                        <span>{{ format('workflowDefId', item.exts.workflowDefId) }}</span>
                      </span>
                      <span class="c_green" v-if="item.exts.dispatched == '1'">
                        {{ format('status', item.status) }}
                      </span>
                      <span v-else class="c_blue">
                        待派单
                      </span>
                    </div>
                    <div>
                      预约：{{
                        item.applyTime ||
                          (item.exts.visitDate
                            ? item.exts.visitDate +
                              ' ' +
                              (item.exts.visitTime && item.exts.visitTime.length > 0
                                ? formatArray('visitTime', item.exts.visitTime)
                                : '')
                            : '') ||
                          '无'
                      }}
                    </div>
                    <div>地址：{{ item.exts.newAddress || item.address }}</div>
                  </el-card>
                </transition-group>
              </draggable>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="甘特图" name="gantt" v-if="false">
          <div class="box-center-tool">
            <ShowGantt></ShowGantt>
          </div>
          <div class="box-center-content c-p-0"></div>
        </el-tab-pane>
        <el-tab-pane label="地图" name="map" v-if="false">
          <div class="box-center-content c-p-0">
            <c-map ref="cMap"></c-map>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''" v-if="collapse">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse"></div>
    </div>
    <el-dialog title="工单" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="90px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="客户姓名">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="formData.name"
            :fetch-suggestions="querySearch"
            placeholder="请输入客户名称"
            @select="handleSelect"
            hide-loading
            value-key="name"
          >
            <i class="el-icon-search el-input__icon" slot="suffix"></i>
            <template slot-scope="{ item }">
              <p class="c-flex c-flex-between">
                <span>{{ item.name }}</span>
                <span>{{ item.phone }}</span>
              </p>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" suffix-icon="el-icon-mobile-phone"></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="area">
          <el-cascader :props="area.props" v-model="formData.area"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="formData.address"
            suffix-icon="el-icon-map-location"
            @blur="getGeocode"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度">
          <el-input
            v-model="formData.gpsPoint.longitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input
            v-model="formData.gpsPoint.latitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </el-form-item>
        <el-form-item label="工单标题" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="优先级">
          <el-radio-group v-model="formData.priority" @change="$forceUpdate()">
            <el-radio v-for="item of options.priority" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预约时间" prop="applyTime">
          <el-date-picker
            v-model="formData.applyTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="描述" prop="describe">
          <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
        </el-form-item>
        <el-form-item label="阶段">
          <el-select v-model="formData.stage">
            <el-option
              v-for="item in options.stage"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formData.status">
            <el-option
              v-for="item in options.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-show="formData.stage == item.value.slice(0, -2)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model.number="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]" @change="$forceUpdate()">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate
              v-model.number="formData.exts[extField.name]"
              @change="$forceUpdate()"
            ></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import cMap from '../components/Map.vue';
import ShowGantt from '../components/ShowGantt.vue';
import draggable from 'vuedraggable';
export default {
  name: 'product',
  components: { cMap, ShowGantt, draggable },
  data() {
    window.$this = this;
    var that = this;
    return {
      width: 300, //默认右边div的宽度
      lastClientX: 0, //记录最后一次拖动的横向位置
      serviceAppointments: [],
      serviceResources: [],
      userData: [],
      fpi: {
        page: 1,
        rows: 20,
        total: 0
      },
      searchFilter:
        '[{"note":"工单状态 等于 待派单","type":"select","fieldName":"status","relation":"is","value":"dispatch"}]',
      searchTime: '',
      searchValue: '',
      openDetail: false,
      formData: {
        priority: 1,
        gpsPoint: {},
        exts: {}
      },
      extFields: [],
      extField: {},
      options: {
        codecfg_status: { codeId: 'STATUS' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_workflowDefId: { codeId: 'workflowDefId' },
        codecfg_visitTime: { codeId: 'timeInterval' },
        codecfg_again: { codeId: 'again' },
        codecfg_workState: { codeId: 'workState' }
      },
      area: {
        options: [],
        props: {
          checkStrictly: true,
          lazy: true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            var nodes = [];
            if (level == '0') {
              nodes = await that.$util.getProvince();
            } else if (level == '1') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getCity(id);
            } else if (level == '2') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getDistrict(id);
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      rules: this.$util.rules,
      activeTab: 'dispatch',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      collapse: false
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'product',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || {};
        for (let item of res.data) {
          if (item.valueOption)
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.osg.codeoption(() => {
          this.getFilterOptions();
          this.getServiceResources(() => {
            this.getServiceAppointments();
          });
          // this.getUsers();
        });
      },
      { noload: true }
    );
    const _this = this;
    this.$nextTick(() => {
      const moveDom = document.getElementById('line'); //拖动元素
      moveDom.onmousedown = function(e) {
        _this.clientStartX = e.clientX;
        document.onmousemove = function(e) {
          _this.moveHandle(e.clientX);
          return false;
        };

        document.onmouseup = function() {
          document.onmousemove = null;
          document.onmouseup = null;
          _this.lastClientX = 0; //清零
        };
        return false;
      };
    });
  },
  methods: {
    dragEnd(e) {
      let srIndex = Number(e.to.id);
      console.log(srIndex);
      this.$set(
        this.serviceResources[srIndex].exts,
        'serviceAppointments',
        this.serviceResources[srIndex].exts.serviceAppointments.sort((a, b) => {
          return a.applyTime - b.applyTime;
        })
      );
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProduct(list) {
      if (list && list.length > 0) {
        let str = '';
        list.map(item => {
          str += item.spec + '、';
        });
        if (str.endsWith('、')) {
          str = str.substring(0, str.length - 1);
        }
        return str;
      }
      return '';
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getServiceAppointments();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getServiceAppointments();
    },
    getFilterOptions() {
      let filters = [];
      this.osg.ajax(
        'queryPlan/selectByTableByInternal.do',
        { tablename: 'serviceAppointment' },
        res => {
          filters = filters.concat(res.data);
          this.osg.ajax(
            'queryPlan/selectByTableByOne.do',
            { tablename: 'serviceAppointment' },
            res => {
              filters = filters.concat(res.data);
              this.options.filters = filters;
              this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
              this.$nextTick(() => {
                if (this.tenantId == '2530349872480957853') {
                  this.searchFilter =
                    '[{"note":"工单状态 等于 待派单","type":"select","fieldName":"status","relation":"is","value":"dispatch"}]';
                }
              });
            },
            { noload: true }
          );
        },
        {
          noload: true
        }
      );
    },
    getServiceAppointments() {
      let params = {
        sortField: 'district',
        sortOrder: 'desc',
        'is:state|integer#and': '1',
        'regex:title|string#or': this.searchValue,
        'regex:orderNum|string#or': this.searchValue,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        // 'lte:applyTime|date#and': this.searchTime ? this.searchTime[1] : '',
        // 'gte:applyTime|date#and': this.searchTime ? this.searchTime[0] : '',
        'lte:exts.visitDate|string#and': this.searchTime ? this.searchTime[1] : '',
        'gte:exts.visitDate|string#and': this.searchTime
          ? this.searchTime[0] && this.searchTime[0].split(' ')[0]
          : ''
      };
      if (this.tenantId == '2530349872480957853') {
        params['_all'] = 1;
      } else {
        params['page'] = this.fpi.page || 1;
        params['rows'] = this.fpi.rows || 20;
      }
      let srs = this.serviceResources;
      let saIds = [];
      for (let sr of srs) {
        sr.exts.serviceAppointments = sr.exts.serviceAppointments || [];
        sr.exts.serviceAppointments.map(item => {
          saIds.push(item._id);
        });
      }
      params['nin:_id|array#and'] = saIds;
      // 添加过滤器参数
      if (this.searchFilter) {
        let paramsObj = {};
        let filters = JSON.parse(this.searchFilter);
        for (var obj of filters) {
          if (obj.type != 'date' && obj.type != 'datetime') {
            var fieldType = 'string';
          } else {
            var fieldType = 'date';
          }
          paramsObj[`${obj.relation}:${obj.fieldName}|${fieldType}#and`] = obj.value;
        }
        Object.assign(params, paramsObj);
      }

      this.osg.ajax('basic/serviceAppointment/query.do', params, res => {
        res.data.map(item => {
          delete item.workflowNodeList;
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        this.$refs.cMap.SAData = res.data;
        // this.$refs.cMap.initMap();
        this.$refs.cMap.layerEditorChange();
      });
    },
    dispatch() {
      this.osg.confirm('是否确认批量派单？', () => {
        console.log('批量派单的数据:', JSON.stringify(this.serviceResources));
        this.osg.ajax(
          '/biz/serviceResource/batchDispatch.do',
          { data: JSON.stringify(this.serviceResources) },
          () => {
            this.osg.toast('批量派单成功', 'success');
            this.getServiceResources(() => {
              this.getServiceAppointments();
            });
          }
        );
      });
    },
    getUsers() {
      let params = {
        page: 1,
        rows: 100
      };
      this.osg.ajax('basic/serviceAppointment/queryByServiceCrew.do', params, res => {
        let userData = [];
        for (let serviceCrew of res.data) {
          userData = userData.concat(serviceCrew.userList);
        }
        this.userData = userData;
        this.$refs.cMap.userData = userData;
        this.$refs.cMap.initMap();
      });
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        priority: 1,
        exts: {},
        gpsPoint: {}
      };
    },
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        var params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
            }
          }
        }
        // delete params.area;
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(params) },
          res => {
            this.doInit();
            this.getServiceAppointments();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    //查询客户
    querySearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 10,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name': queryString
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          cb(res.data);
        },
        { noload: true }
      );
    },
    //选择客户
    handleSelect(item) {
      let contactIds = this.formData.contactIds || [];
      contactIds.push(item._id);
      this.$set(this.formData, 'contactId', contactIds);
      this.$set(this.formData, 'phone', item.phone);
      this.$set(this.formData, 'address', item.address);
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            var cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.$forceUpdate();
        });
      }
    },
    getServiceResources(callback) {
      this.osg.ajax(
        '/biz/serviceResource/pdQuery.do',
        {
          _all: '1',
          'ne:_id|string#and': '6265064012172144659',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.serviceResources = res.data;
          if (callback) callback();
        }
      );
    },
    // 拖拽方法
    moveHandle(nowClient) {
      if (this.lastClientX === 0) {
        // 第一次拖动 记录起始位置
        this.lastClientX = nowClient;
      } else {
        // 计算拖动的距离 赋值给右边div
        this.width += this.lastClientX - nowClient;
        // 记录最后一个的拖动位置
        this.lastClientX = nowClient;
      }
    },
    setLeftStyle() {
      let wid = this.width + 7 + 'px';
      //左边div的宽度 等于 100% - （右边div + line的宽度）
      return `width: calc(100% - ${wid});`;
    },
    setRightStyle() {
      let wid = this.width + 'px !important';
      return `width:${wid};`;
    }
  }
};
</script>
<style scoped>
.box-left {
  min-width: auto !important;
  max-width: none !important;
  flex-basis: unset !important;
  /* width: 780px !important; */
}
.box-left-content {
  padding: 0 10px;
}
#app .box-center {
  padding: 11px 15px 10px;
  min-width: 300px !important;
}
.filter {
  margin: 10px 10px 0;
  border-bottom: 1px solid #dfe3eb;
}
.filter > div {
  margin-bottom: 10px;
}

/* .box-left {
  min-width: 500px !important;
} */

.sr-card {
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0;
  height: 93px;
  min-height: 93px;
  display: flex;
  border-radius: 4px;
}
>>> .sr-card .el-card__body {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 10px;
}
>>> .card-sr .el-card__body {
  width: 150px;
  flex-direction: column;
  justify-content: center;
  background: #409eff;
  color: #fff;
}
.card-sas {
  flex: 1;
  overflow-x: auto;
}
.card-sas > span {
  display: flex;
  height: 100%;
}
.card-sas > span > .el-card {
  flex-shrink: 0;
  margin-left: 5px;
}
>>> .card-sas > span > .el-card .el-card__body {
  width: 200px;
  align-items: flex-start;
  flex-shrink: 0;
  font-size: 12px;
  padding: 5px;
}
.el-table .el-table__cell {
  padding: 0 !important;
}
/* 左侧工单目标位置占位符的样式及需要停靠位置的样式 */
.sa-ghost {
  width: 930px;
  background: #f2f2f2;
  display: flex;
}
/* 右侧目标位置占位符的样式及需要停靠位置的样式 */
.sr-ghost {
  margin-left: 5px;
  padding: 5px !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 200px;
  height: 93px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  background: #f2f2f2;
  flex-shrink: 0;
  font-size: 12px;
}
/* 中间拖拽线样式 */
.line {
  border: 1px solid grey;
  text-align: center;
  line-height: 600px;
}
.line span:hover {
  cursor: w-resize;
}
</style>
